import { useState } from "react";
import { useSnackBars } from "../../../contexts/Snackbar/SnackbarContext";
import { useMutation, useQueryClient } from "react-query";
import { useNavigate, useParams } from "react-router-dom";
import { PersonService } from "../../../services/PersonService";
import { routes } from "../../../utils/paths";
import { namesUseQuery, typeObject } from "../../../utils/constants";
import { ContainerTitle } from "../PetsBO/PetsBO.styled";
import { ButtonLoading } from "../../ButtonLoading";
import { ModalViewQr } from "../../ModalViewQr/ModalViewQr";
import { getUrlPersonQr } from "../../../utils/functions";
import { ButtonCustom } from "../../Common.styled";
import { TablePerson } from "./TablePerson";
import { theme } from "../../theme";
import { useCountPersons } from "../../../hooks/BO/useContPersons";
import { BuscadorDePropietarios } from "../BuscadorDePropietarios";

export const PersonBO = () => {
  const [viewAll, setviewAll] = useState(false);
  const [openBusqueda, setOpenBusqueda] = useState(false);
  const { showErrorSnackbar } = useSnackBars();

  const queryClient = useQueryClient();
  const navigate = useNavigate();
  let { newQR } = useParams();

  const mutateGenerateQR = async () => {
    const response = await PersonService.generateQR();
    return response;
  };

  const { mutate, isLoading } = useMutation(mutateGenerateQR, {
    onSuccess: (id) => {
      navigate(routes.adminPerson + "/" + id);
      queryClient.invalidateQueries(namesUseQuery?.ALL_PERSONS);
    },
    onError: (err) => {
      console.error(err);
      showErrorSnackbar(err?.response?.data?.body);
    },
  });
  const { data } = useCountPersons();

  return (
    <div>
      <ContainerTitle>
        <h1>Personas</h1>
        <ButtonLoading
          isLoading={isLoading}
          onClick={mutate}
          sx={{ height: 40 }}
        >
          Generar Nueva persona
        </ButtonLoading>
        <ModalViewQr
          paramQRBO={newQR}
          name={newQR}
          position={"relative"}
          url={getUrlPersonQr(newQR)}
          id={newQR}
          qrColor={theme.palette.common.blueQRPerson}
        />
      </ContainerTitle>

      <ButtonCustom
        onClick={() => {
          setOpenBusqueda(true);
        }}
      >
        Busqueda
      </ButtonCustom>
      {/* {openBusqueda && (
        <SearchPet open={openBusqueda} onClose={() => setOpenBusqueda(false)} />
      )} */}
      {openBusqueda && (
        <BuscadorDePropietarios
          type={typeObject.persons}
          open={openBusqueda}
          onClose={() => setOpenBusqueda(false)}
          service={(email) => PersonService.itemsByEmail(email)}
        />
      )}
      <h4>Cantidad de personas creadas: {data?.created}</h4>
      <h4>Cantidad de personas registradas: {data?.registered}</h4>
      <ButtonCustom onClick={() => setviewAll(true)}>
        Mostrar todos
      </ButtonCustom>
      {viewAll && <TablePerson />}
    </div>
  );
};
